// Count home and secondary sections
export const DEFAULT_SIDE_NAV_SECTION_COUNT = 2;
